import { createApp } from 'vue'
import App from './App.vue'
import './assets/index.css';

createApp(App).mount('#app')
